import React from 'react';
import paramedicImage from '@/assets/uniforms/paramedic.png';
import optimizedParamedicImage from '@/assets/uniforms/paramedic-optimized.svg';

export default function ParamedicUniformSvg({ className = '', title = null }) {
  return (
    <picture
      className={className}
      style={{ display: 'block', objectFit: 'contain', objectPosition: 'center' }}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      data-template="paramedic-fixed-png-v6"
    >
      <source type="image/svg+xml" srcSet={optimizedParamedicImage} />
      <img
        src={paramedicImage}
        alt={title || ''}
        style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center', display: 'block' }}
      />
    </picture>
  );
}
